<div class="grid-col-12 grid-max-width no-row-gap ms-xlarge-t">
  <div class="col-1-12 md-col-2-11 mr-xlarge-b">
    <h2 class="nordic-blue-900-text font-heading-2 mr-medium-b">
      {{ 'LOYALTY.upgradeAvailability.title' | finLocalization }}
    </h2>
    <div class="font-body-1">
      <span>
        {{ 'LOYALTY.upgradeAvailability.intro.paragraph1' | finLocalization }}
      </span>
      <span
        class="mr-small-t block"
        [innerHTML]="'LOYALTY.upgradeAvailability.intro.paragraph2' | finLocalization: { ref: upgradeUrl }"
      >
      </span>
      <span class="mr-small-t block">
        {{ 'LOYALTY.upgradeAvailability.intro.paragraph3' | finLocalization }}
      </span>
    </div>
  </div>
  <div class="col-1-12 md-col-2-11 mr-xlarge-b">
    <fin-upgrade-availability></fin-upgrade-availability>
  </div>
  <div class="col-1-12 md-col-2-11 mr-small-b">
    <h2
      class="custom-decorated-heading custom-decorated-heading--nordic-blue-900 nordic-blue-900-text font-heading-2 mr-small-b pr-large-t"
    >
      {{ 'LOYALTY.upgradeAvailability.subHeading' | finLocalization }}
    </h2>
    <div>
      <span class="font-body-1 mr-small-b block">
        {{ 'LOYALTY.upgradeAvailability.subParagraph.0' | finLocalization }}
      </span>
      <span class="font-body-1 mr-small-b block">
        {{ 'LOYALTY.upgradeAvailability.subParagraph.1' | finLocalization }}
      </span>
      <span class="font-body-1 mr-small-b block">
        {{ 'LOYALTY.upgradeAvailability.subParagraph.2' | finLocalization }}
      </span>
      <span *ngIf="upgradeTermsLink$ | async as link" class="font-body-1 mr-small-b block">
        <a [href]="link.target.url" class="underline nordic-blue-900-text" data-testid="upgrade-travel-terms">{{
          link.teaserTitle
        }}</a>
      </span>
      <div class="flex flex--end">
        <fcom-button
          [text]="'LOYALTY.upgradeAvailability.upgradeTo' | finLocalization"
          [size]="ButtonSize.LARGE"
          (clickBtn)="upgradeTo()"
        >
        </fcom-button>
      </div>
    </div>
  </div>
</div>
